import React, { createContext, useContext, useState } from 'react';
import EditFileSystemNodeTagsDialog from './EditFileSystemNodeTagsDialog';

const EditFileSystemNodeTagsDialogContext = createContext();
export const useEditFileSystemNodeTagsDialog = () => useContext(EditFileSystemNodeTagsDialogContext);

function EditFileSystemNodeTagsDialogProvider(props) {
    const { children } = props;

    const [ isEditFileSystemNodeTagsDialogOpen, setIsEditFileSystemNodeTagsDialogOpen ] = useState(false);
    const [ fileSystemNodePath, setFileSystemNodePath ] = useState([]);

    const open = (fileSystemNodePath) => {
        setFileSystemNodePath(fileSystemNodePath);
        setIsEditFileSystemNodeTagsDialogOpen(true);
    }

    return (
        <EditFileSystemNodeTagsDialogContext.Provider value={{ open }}>
            {children}
            <EditFileSystemNodeTagsDialog open={isEditFileSystemNodeTagsDialogOpen} fileSystemNodePath={fileSystemNodePath} handleCancel={() => {setIsEditFileSystemNodeTagsDialogOpen(false)}}/>
        </EditFileSystemNodeTagsDialogContext.Provider>
    );
}
export default EditFileSystemNodeTagsDialogProvider;